export default __webpack_public_path__ + "img/recyclable-cover.asset.b11f9f55.jpg";